import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { Box, IconButton, Tooltip } from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

function GetHoldingKey() {
    const {t} = useTranslation('holdingPackagesManagement');
    const dispatch = useDispatch();
    const [holdingKey, setHoldingKey] = useState('');

    const getHoldingKey = useSelector(state => state.hpmReducer.getHoldingKey);

    function handleCopyHoldingKey(){
        navigator.clipboard.writeText(holdingKey.toString())
        dispatch(showAlertSnackbar({ title: 'Copy', message: t('copy_success'), type: 'success' }))
    }

    useEffect(() => {
        if(getHoldingKey) {
            setHoldingKey(getHoldingKey);
        }
    }, [getHoldingKey])

    return (
        <Box style={{ display: 'flex' }}>
            { holdingKey ?
            <>
                <span>{t('holding_key')}</span>
                <span>{holdingKey}</span>
                <Tooltip title={t('copy_title')}>
                    <IconButton size="small" onClick={handleCopyHoldingKey}>
                        <FileCopy fontSize="inherit"/>
                    </IconButton>
                </Tooltip>
            </>
            : null}
        </Box>
    );
}

export default GetHoldingKey;